<template>
  <tr class="monitoring-table-item">
    <td>
      {{ warning.info }}
    </td>

    <td>
      {{ type }}
    </td>

    <td>
      {{ creationDate }}
    </td>

    <td class="monitoring-table-item-detail">
      <app-select :value="status"
                  :data-title="$t('message.monitoring.message.campaign')"
                  :data-menu-heading="$t('message.monitoring.message.campaigns')"
                  data-menu-width="auto"
                  :data-button-gradient="true"
                  :data-items="possibleStatus"
                  @search="v => search(v)"
                  @input="setStatus" />
    </td>
  </tr>
</template>

<script>
    import AppSelect from '@components/Select'
    import moment from 'moment';

    export default {
      components: {
        AppSelect
      },
      props: {
        warning: {
          type: Object,
          required: true
        }
      },


        data() {
            return {
              status: this.warning.status,

            }
        },

        methods: {
          async setStatus(val) {
            try {
              await this.$api.systemWarning.status({
                id: this.warning.id,
                status: val
              })

              this.status = val
            } catch (error) {
              console.log(error)
            }
          }
        },

        computed: {
          type() {
            return {
              ['LOCAL_WITHOUT_CAMPAIGN']: this.$t('message.monitoring.message.noActiveCampaign'),
              ['ADVERTISER_WITHOUT_CAMPAIGN']: this.$t('message.monitoring.message.noActiveCampaign'),
              ['LOCAL_WITHOUT_ACCESS']: this.$t('message.monitoring.message.noAccesses'),
            }[this.warning.warningType]
          },

          creationDate() {
            const dateMoment = moment(this.warning.creationDate)
            return `${dateMoment.format('LL')} às ${dateMoment.format('LT')}`
          },

          possibleStatus() {
            return  ['OPEN', 'RESOLVING', 'CLOSED', 'AUTO_CLOSED'].map((val) => {
                  const label = {
                      ['OPEN']: this.$t('message.monitoring.message.open'),
                      ['RESOLVING']: this.$t('message.monitoring.message.resolving'),
                      ['CLOSED']: this.$t('message.monitoring.message.closed'),
                      ['AUTO_CLOSED']: this.$t('message.monitoring.message.autoClosed'),
                  }[val]

                  return{
                      label,
                      id: val
                  }
              })
          }
        }

    }
</script>

<style lang="scss" scoped>
</style>
